import { wait, catchError } from "$app/utils"
import { xhr } from "$app/utils/xhr"
import type { Editor } from "@tiptap/core"

/**
 * Replace link with opengraph if there is opengraph data
 * @param editor
 * @param text
 */
export async function setOpenGraph(
  editor: Editor,
  text: string
): Promise<void> {
  if (!text) return
  await wait(50)

  let link = editor.view.dom.querySelector(`a[href='${text}']`)
  if (!link) return

  let [err, resp] = await catchError(
    xhr.post("/api/v1/opengraph", { url: text })
  )

  if (err || resp.status !== 200) return // We can alert the user here

  link = editor.view.dom.querySelector(`a[href='${text}']`)
  if (!link) return
  let p = link.parentNode as HTMLParagraphElement
  if (!p) return

  if (!resp.data?.meta["og:image"] || !resp.data?.meta["og:title"]) return

  let img: HTMLImageElement | null = createOpenGraphHTMLImage(resp.data.meta)
  let title = resp.data.meta["og:title"]

  let textAfter = link?.nextSibling?.textContent || ""
  let textBefore = link?.previousSibling?.textContent || ""

  let a = document.createElement("a")
  a.href = text
  a.setAttribute("target", "_blank")
  a.textContent = title
  if (img) a.appendChild(img)


  if (textBefore) {
    let np = document.createElement("p")
    np.textContent = textBefore
    editor.view.dom.insertBefore(np, p)
  }

  editor.view.dom.insertBefore(a, p)

  if (textAfter) {
    let np = document.createElement("p")
    np.textContent = textAfter
    editor.view.dom.insertBefore(np, p)
  }

  if (!textBefore && !textAfter) {
    editor.commands.insertContent(a.outerHTML)
  }

  p.remove()
}

/**
 * Create image from open graph data
 */
function createOpenGraphHTMLImage(
  data: Record<string, string>
): HTMLImageElement | null {
  if (!data["og:image"]) return null

  let img = document.createElement("img")
  img.src = data["og:image"]
  img.alt = data["og:title"]
  img.classList.add("w-full", "h-auto")
  img.setAttribute("src", data["og:image"])
  img.setAttribute("alt", data["og:title"])
  img.setAttribute("data-width", data["og:image:width"])
  img.setAttribute("data-height", data["og:image:height"])

  return img
}
